import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import sr from './locales/sr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import { getLangFromPath } from './lang.mjs';

/* URL is the single source of truth for language. localStorage ('vb_lang')
   is only used as a soft hint for returning visitors on the prefix-less root
   (see LanguageRedirect in App.js), never to override an explicit /en, /de. */
const urlLang = typeof window !== 'undefined'
  ? getLangFromPath(window.location.pathname)
  : 'sr';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      sr: { translation: sr },
      en: { translation: en },
      de: { translation: de },
    },
    lng: urlLang,
    fallbackLng: 'sr',
    interpolation: { escapeValue: false },
    initImmediate: false,
  });

export default i18n;
